import { timeScaleTypesSet } from '../scale/scaleCategories';
/**
 * Convert each element in the array into
 * - Date (for time scales)
 * - number (for other continuous scales)
 * @param domain
 * @param scaleType
 */

export default function parseContinuousDomain(domain, scaleType) {
  if (timeScaleTypesSet.has(scaleType)) {
    return domain.filter(d => typeof d !== 'boolean').map(d => typeof d === 'string' || typeof d === 'number' ? new Date(d) : d);
  }

  return domain.map(d => typeof d === 'string' || typeof d === 'boolean' ? Number(d) : d);
}